import Fingerprint2 from 'fingerprintjs2';

const fingerprintOptions = {
    excludes: { canvas: true, webgl: true, fonts: true, audio: true }
};
const fingerprintColumnMapping = {
    userAgent: 'p1',
    webdriver: 'p2',
    language: 'p3',
    colorDepth: 'p4',
    deviceMemory: 'p5',
    pixelRatio: 'p6',
    hardwareConcurrency: 'p7',
    screenResolution: 'p7',
    availableScreenResolution: 'p8',
    timezoneOffset: 'p9',
    timezone: 'p10',
    sessionStorage: 'p11',
    localStorage: 'p12',
    indexedDb: 'p13',
    addBehavior: 'p14',
    openDatabase: 'p15',
    cpuClass: 'p16',
    platform: 'p17',
    doNotTrack: 'p18',
    plugins: 'p19',
    webglVendorAndRenderer: 'p20',
    adBlock: 'p21',
    hasLiedLanguages: 'p22',
    hasLiedResolution: 'p23',
    hasLiedOs: 'p24',
    hasLiedBrowser: 'p25',
    touchSupport: 'p26',
    fontsFlash: 'p27',
    enumerateDevices: 'p28'
};

let fingerprint = null;

export const getFingerprint = () => {
    return new Promise(resolve => {
        if (fingerprint != null) return resolve(fingerprint);

        Fingerprint2.get(fingerprintOptions, components => {
            if (components && Array.isArray(components)) {
                const fingerprintRaw = components
                    .map(c => {
                        const key = fingerprintColumnMapping[c.key]
                            ? fingerprintColumnMapping[c.key]
                            : c.key;
                        return `${key}:${c.value}`;
                    })
                    .join();
                fingerprint = window.btoa(fingerprintRaw);
                return resolve(fingerprint);
            }
            return resolve('');
        });
    });
};
